module.exports = __webpack_public_path__ + "static/aloopcards-f1e8552843306228563552f42de03d09.png";